import React from "react";
import { Oval } from "react-loader-spinner";
import NoRecordMessage from "../others/NoRecordMessage";

interface SpinningLoaderProps {
  isLoading: boolean;
  hasData: boolean;
}
const SpinningLoader = (props: SpinningLoaderProps) => {
  return (
    <div>
      {props.isLoading && (
        <div className="w-full h-full flex items-center justify-center">
          <Oval
            height="25"
            width="25"
            color="white"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      {!props.isLoading && !props.hasData && (
        <div>
          <NoRecordMessage title="No records" message="We found no record" />
        </div>
      )}
    </div>
  );
};

export default SpinningLoader;
